// AUTO-GENERATED. Do not edit.
export default {
  "lightGrey": "#f6f6f6",
  "midtoneGrey": "#e3e3e3",
  "mediumGrey": "#aaaaaa",
  "grey": "#aaaaaa",
  "darkGrey": "#828282",
  "paleBlue": "#f4faff",
  "lightBlue": "#e7f5ff",
  "midtoneBlue": "#afddff",
  "mediumBlue": "#0096ff",
  "blue": "#0096ff",
  "darkBlue": "#0673f4",
  "lightNavy": "#e8e8f3",
  "midtoneNavy": "#bbb9db",
  "mediumNavy": "#19369d",
  "navy": "#19369d",
  "darkNavy": "#040052",
  "lightOrange": "#fff7e7",
  "midtoneOrange": "#ffe6bb",
  "mediumOrange": "#ffa405",
  "orange": "#ffa405",
  "darkOrange": "#dd7e03",
  "lightRed": "#ffe5e8",
  "midtoneRed": "#ffacb6",
  "mediumRed": "#ec1314",
  "red": "#ec1314",
  "darkRed": "#bf011a",
  "lightYellow": "#fffde8",
  "midtoneYellow": "#fff6b0",
  "mediumYellow": "#fece05",
  "yellow": "#fece05",
  "darkYellow": "#f3ba08",
  "lightPink": "#fff3f3",
  "midtonePink": "#ffdbdb",
  "mediumPink": "#ff7c7c",
  "pink": "#ff7c7c",
  "darkPink": "#dc6569",
  "lightGreen": "#f6ffe8",
  "midtoneGreen": "#c2f6da",
  "mediumGreen": "#36cf9f",
  "green": "#36cf9f",
  "darkGreen": "#2ca47e",
  "lightOlive": "#f1f5ed",
  "midtoneOlive": "#d5e1ca",
  "mediumOlive": "#62933e",
  "olive": "#62933e",
  "darkOlive": "#49672f",
  "lightPurple": "#f1e8ff",
  "midtonePurple": "#e1c9fd",
  "mediumPurple": "#b36be0",
  "purple": "#b36be0",
  "darkPurple": "#864fa7",
  "lightBrown": "#f8efe9",
  "midtoneBrown": "#e9cfbe",
  "mediumBrown": "#ad4f0e",
  "brown": "#ad4f0e",
  "darkBrown": "#612c0a",
  "lightFuchsia": "#fbdcee",
  "midtoneFuchsia": "#f6b5db",
  "mediumFuchsia": "#e83fa1",
  "fuchsia": "#e83fa1",
  "darkFuchsia": "#be3483",
  "white": "#ffffff",
  "black": "#000000",
  "lightBorder": "#eeeeee",
  "midtoneBorder": "#e6e6e6",
  "mediumBorder": "#dddddd",
  "tooltip": "#626262",
  "lightBackground": "#fbfcfd",
  "midtoneBackground": "#f7fafb",
  "mediumBackground": "#f5f8fa",
  "lightBlueBackground": "#f1f8fe",
  "midtoneBlueBackground": "#f2f6fb",
  "mediumBlueBackground": "#eaf3f9",
  "midtoneRedBackground": "#fcf0f0",
  "lightMediumGreen": "#dffddf",
  "lightMediumOrange": "#fbe8d9",
  "lightWarmGrey": "#F7F7F7",
  "grapefruit": "#ff5a5f",
  "blackText": "#484848",
  "greyText": "#767676",
  "greyBackground": "#fcfcfc",
  "midtoneGreyBackground": "#eae8e6"
};
